import { render } from "./About.vue?vue&type=template&id=38767eaa&scoped=true"
import script from "./About.vue?vue&type=script&lang=js"
export * from "./About.vue?vue&type=script&lang=js"

import "./About.vue?vue&type=style&index=0&id=38767eaa&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-38767eaa"

export default script